import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
  Theme,
  IconButton,
  InputAdornment,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const MultiSelect = ({
  options,
  onChange,
  label,
  value: controlledValue,
  sx,
  clearable = false,
}: {
  options: {
    description?: string | null;
    id: string;
    name: string;
  }[];
  onChange: (e: any) => void;
  label?: string;
  value?: string[];
  /** Overrides for the wrapping FormControl (width / spacing / field height). */
  sx?: SxProps<Theme>;
  clearable?: boolean;
}) => {
  const [selectedNames, setSelectedNames] = useState<string[]>(
    controlledValue ?? []
  );

  useEffect(() => {
    if (controlledValue !== undefined) {
      setSelectedNames(controlledValue ?? []);
    }
  }, [controlledValue]);

  const handleSelection = (event: any) => {
    const selectedValue = event.target.value;
    if (selectedNames.includes(selectedValue)) {
      setSelectedNames([
        ...selectedNames.filter((name) => name !== selectedValue),
      ]);
    } else {
      setSelectedNames([...selectedValue]);
    }
    onChange(selectedValue);
  };

  return (
    <FormControl
      sx={[{ m: 1, width: 300 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {!!!selectedNames.length && (
        <InputLabel
          // sx (not inline style) so callers passing `sx` can reposition it.
          sx={{
            position: "absolute",
            top: "10px",
            left: "20px",
            color: "gray",
          }}
          id="demo-multiple-checkbox-label"
        >
          {label ? label : "Filter By States"}
        </InputLabel>
      )}
      <Select
        multiple
        value={selectedNames}
        onChange={(e) => handleSelection(e)}
        MenuProps={MenuProps}
        renderValue={
          clearable
            ? (ids: string[]) =>
                ids
                  .map(
                    (id) =>
                      options.find((option) => option.id === id)?.name ?? id
                  )
                  .join(", ")
            : undefined
        }
        endAdornment={
          clearable && selectedNames.length > 0 ? (
            <InputAdornment position="end" sx={{ mr: 2 }}>
              <IconButton
                size="small"
                aria-label={`Clear ${label ?? "filter"}`}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                  event.stopPropagation();
                  setSelectedNames([]);
                  onChange([]);
                }}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined
        }
      >
        {options?.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox checked={selectedNames.indexOf(option.id) > -1} />
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelect;
